export enum ProductRelationDirectionEnum {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
}
